import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import supplierService from '../../../services/supplierService';

const GeographicDistributionMap = ({ language, supplierId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const content = {
    en: {
      title: 'Geographic Sales Distribution',
      subtitle: 'Buyer locations and revenue by country',
      country: 'Country',
      buyers: 'Buyers',
      revenue: 'Revenue',
      noData: 'No geographic data available'
    },
    zh: {
      title: '地理销售分布',
      subtitle: '买家位置和国家收入',
      country: '国家',
      buyers: '买家',
      revenue: '收入',
      noData: '没有地理数据'
    }
  };

  const t = content?.[language];

  useEffect(() => {
    loadGeographicData();
  }, [supplierId]);

  const loadGeographicData = async () => {
    try {
      setLoading(true);
      const distribution = await supplierService?.getBuyerGeographicDistribution(supplierId);
      setData(distribution);
    } catch (error) {
      console.error('Failed to load geographic data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-center h-64">
          <Icon name="Loader2" size={32} className="animate-spin text-primary" />
        </div>
      </div>
    );
  }

  const maxRevenue = Math.max(...data?.map(d => d?.revenue || 0), 1);

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-2">
          <Icon name="Globe" size={20} className="text-primary" />
          <h3 className="text-lg font-heading font-semibold text-foreground">{t?.title}</h3>
        </div>
        <p className="text-sm text-muted-foreground">{t?.subtitle}</p>
      </div>

      {data?.length === 0 ? (
        <div className="text-center py-12">
          <Icon name="MapPin" size={48} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">{t?.noData}</p>
        </div>
      ) : (
        <div className="space-y-4">
          {data?.map((item, index) => (
            <div key={index} className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <div className="flex items-center gap-2">
                  <Icon name="MapPin" size={16} className="text-primary" />
                  <span className="font-medium text-foreground">{item?.country}</span>
                </div>
                <div className="flex items-center gap-4 text-muted-foreground">
                  <span>{item?.count} {t?.buyers}</span>
                  <span className="font-semibold text-foreground">
                    ${Number(item?.revenue)?.toLocaleString()}
                  </span>
                </div>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div
                  className="bg-primary rounded-full h-2 transition-all"
                  style={{ width: `${(item?.revenue / maxRevenue) * 100}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default GeographicDistributionMap;